/**
 * GeneralSettings - Presenter Component (ADR-034)
 *
 * Pure presenter: receives all data and callbacks via props.
 * ZERO store access. ZERO API calls.
 */

import React from 'react';
import { Card, Select, Form } from 'antd';

const { Option } = Select;

export interface GeneralSettingsProps {
  theme: string;
  units: string;
  onThemeChange: (value: string) => void;
  onUnitsChange: (value: string) => void;
}

const GeneralSettings: React.FC<GeneralSettingsProps> = ({
  theme,
  units,
  onThemeChange,
  onUnitsChange,
}) => {
  return (
    <>
      <Card title="Theme Settings" style={{ marginBottom: '1rem' }}>
        <Form layout="vertical">
          <Form.Item label="Current Theme">
            <Select value={theme} onChange={onThemeChange}>
              <Option value="dark">Dark</Option>
              <Option value="light">Light</Option>
            </Select>
          </Form.Item>
        </Form>
      </Card>
      <Card title="Units of Measurement">
        <Form layout="vertical">
          <Form.Item label="Measurement System">
            <Select value={units || 'metric'} onChange={onUnitsChange}>
              <Option value="metric">Metric (meters, kg, °C)</Option>
              <Option value="imperial">Imperial (feet, lbs, °F)</Option>
            </Select>
          </Form.Item>
        </Form>
      </Card>
    </>
  );
};

export default GeneralSettings;